import { selectedCurrentProposalStatusName } from '../../../../../../features/gms-state-and-modal/state-slice';
import { useSelector } from 'react-redux';
import { selectProposalExpiredAt } from '../../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import ProposalPreviewDataModal from '../../preview-proposal-data/proposal-preview-data-modal';
import ProposalActionBtn from './proposal-action-btn';
import { TypeOfActionProposal } from '../../../../../../types/type';
import { getStatusClasses } from '../../../../../../helper/status';
import ProposalCountDownContainer from '../proposal-count-down-container';
import { useProposalTypeData } from '../../../../../../hooks/proposal/use-proposal-type-data';

interface Props {
    typeOfIcon: TypeOfActionProposal;
}

export default function ProposalInformation({ typeOfIcon }: Props) {

    const {
        isDraftProposal,
        isBookedProposal,
        isClosedProposal,
    } = useProposalTypeData()
    const currentStatus = useSelector(selectedCurrentProposalStatusName);
    const expiry_date = useSelector(selectProposalExpiredAt);
    const showCountdown = !!expiry_date && !isDraftProposal && !isClosedProposal && !isBookedProposal;

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden rounded border px-0.5 pb-0.5">

            {/* ================================================= */}
            {/* STATUS HEADER */}
            {/* STATUS HEADER */}
            {/* ================================================= */}
            <div className="shrink-0 border-b border-gray-200 bg-white px-3 py-2.5 sm:px-4 sm:py-3">
                <div className="flex flex-wrap items-center gap-2">
                    {/* STATUS */}
                    <div className="min-w-0 flex-1">
                        <div className={`inline-flex max-w-full items-center gap-1.5 rounded-md border px-2.5 py-1.5 font-semibold uppercase tracking-wide ${getStatusClasses(currentStatus ?? '')}`}>
                            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-70" />
                            <span className="truncate text-[9px] font-semibold sm:text-[10px]">{currentStatus || '-'}</span>
                        </div>
                    </div>

                    {/* VIEW ACTIONS */}
                    {/* <div className="order-3 flex w-full items-center gap-1.5 sm:order-2 sm:w-auto">
                        <button type="button" className="flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-md border border-[#186cb2]/20 bg-[#186cb2]/5 px-2.5 py-1.5 text-[#186cb2] transition hover:border-[#186cb2]/40 hover:bg-[#186cb2]/10 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#186cb2]/20 sm:flex-none">
                            <span className="truncate text-[9px] font-semibold sm:text-[10px]">View Proposal Data</span>
                        </button>
                        <button type="button" className="flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-md border border-[#186cb2]/20 bg-[#186cb2]/5 px-2.5 py-1.5 text-[#186cb2] transition hover:border-[#186cb2]/40 hover:bg-[#186cb2]/10 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#186cb2]/20 sm:flex-none">
                            <span className="truncate text-[9px] font-semibold sm:text-[10px]">View Rates Data</span>
                        </button>
                    </div> */}

                    {/* COUNTDOWN */}
                    {showCountdown && (
                        <div className="ml-auto shrink-0">
                            <ProposalCountDownContainer expiryDate={expiry_date} />
                        </div>
                    )}
                </div>
            </div>
            {/* ================================================= */}
            {/* PROPOSAL CONTENT */}
            {/* ================================================= */}
            <div className="flex-1 min-h-0 overflow-y-auto py-2 mb-1 px-1">
                <ProposalPreviewDataModal />
            </div>
            {/* ================================================= */}
            {/* ACTIONS */}
            {/* ================================================= */}
            <div className="shrink-0 border-t border-gray-200 bg-white px-2.5 py-2 sm:px-3 sm:py-2.5">
                <ProposalActionBtn typeOfIcon={typeOfIcon} />
            </div>
        </div>
    );
}
